import { FormActions } from "../../components/common/FormActions";
import { TransactionStatusTag } from "../../components/common/registerUtils";
import { CAN_ADMIN } from "../../utils/constants";
import {
  createViewAction,
  formatCurrency,
  formatDateTime,
  itemExists,
  useGetUserPermissions,
} from "../../utils/helpers";
import { URL_MERCHANT_PAYMENTS } from "../../utils/urls";

const url = URL_MERCHANT_PAYMENTS;

// REGISTER
export const useMerchantPayments = () => {
  const permissions = useGetUserPermissions();
  const tableColumns = () => [
    {
      id: "payer_name",
      header: "Payer Name",
      filter: {},
    },
    {
      id: "phone_number",
      header: "Phone Number",
      filter: {},
    },

    {
      id: "amount",
      header: "Amount",
    },
    ...(itemExists(permissions, [CAN_ADMIN])
      ? [
          {
            id: "merchant_owner",
            header: "Parent Merchant",
            filter: {},
          },
        ]
      : []),
    {
      id: "merchant_code_value",
      header: "Merchant Code",
      filter: {},
    },
    {
      id: "merchant_alias",
      header: "Merchant Alias",
      filter: {},
    },
    {
      id: "payment_type",
      header: "Payment Type",
      filter: {},
    },
    {
      id: "reference",
      header: "Reference",
      filter: {},
    },
    {
      id: "status",
      header: "Payment Status",
      filter: {
        type: "text",
      },
    },
    {
      id: "created_at",
      header: "Payment Date",
      filter: {
        type: "date",
      },
    },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        status: <TransactionStatusTag status={item?.status} />,
        amount: formatCurrency(item?.amount),
        created_at: formatDateTime(item?.created_at),
        actions: <FormActions actions={[createViewAction(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Merchant Codes Payments Details",
          fields: {
            transaction_id: item?.id,
            merchant_name: item?.merchant_owner,
            merchant_code_value: item?.merchant_code_value,
            merchant_alias: item?.merchant_alias,
            amount: item?.amount,
            payer_id: item?.payer,
            payer_name: item?.payer_name,
            phone_number: item?.phone_number,
            payment_type: item?.payment_type,
            reference: item?.reference,
            notes: item?.notes,
            status: <TransactionStatusTag status={item?.status} />,
            payment_date: formatDateTime(item?.created_at),
          },
        },
      ],
    };
  };

  return { tableData, tableColumns, viewData };
};
